import { createSelector } from '@ngrx/store';
import {
  AddressBookActions,
  GET_ADDRESS_BOOK_SUCCESS,
  RESET_ADDRESS_BOOK,
  SET_ADDRESS_BOOK_PARAMS
} from './address-book.actions';
import { AddressBookState, defaultAddressBookPager } from './address-book-params.interface';

export const initialState: AddressBookState = {
  addressBook: {
    total: 0,
    data: []
  },
  params: {
    sortBy: 'contactName',
    pager: defaultAddressBookPager
  }
};

export function addressBookReducer(
  state: AddressBookState = initialState,
  action: AddressBookActions
): AddressBookState {
  switch (action.type) {
    case GET_ADDRESS_BOOK_SUCCESS:
      return {
        ...state,
        addressBook: action.payload
      };
    case SET_ADDRESS_BOOK_PARAMS:
      return {
        ...state,
        params: action.payload
      };
    case RESET_ADDRESS_BOOK:
      return {
        ...initialState
      };
    default: {
      return state;
    }
  }
}

export const getAddressBookMainState = (state): AddressBookState => state.addressBook;

export const getWholeAddressBookState = (addressBookState: AddressBookState): AddressBookState => addressBookState;

export const getWholeAddressBookSelector = createSelector(getAddressBookMainState, getWholeAddressBookState);
